import { faUpload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import PropsType from 'props-type';
import { useDispatch } from 'react-redux';

import BulkRequestExcelUploadButton from '@app/containers/BulkRequestExcelUploadButton';
import { modalClose } from '@app/store/modal/actions';

import ExcelValidationError from './ExcelValidationError';

import './BulkRequestExcelValidationErrorModal.scss';

const propTypes = {
  bulkRequestId: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      columnName: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired
  ),
};

const defaultProps = {
  errors: [],
};

type BulkRequestExcelValidationErrorModalProps = PropsType<typeof propTypes, typeof defaultProps>;

function BulkRequestExcelValidationErrorModal({
  bulkRequestId,
  errors,
}: BulkRequestExcelValidationErrorModalProps) {
  const dispatch = useDispatch();
  return (
    <div className="Container Container--xmd">
      <div className="Card Card--pop WindowModal WindowModal--fixed-height">
        <div className="WindowModal__header">
          <h4 className="WindowModal__header-title">
            <FontAwesomeIcon icon={faUpload} /> 엑셀 업로드
          </h4>
          <button
            className="WindowModal__header-close-btn"
            name="close"
            type="button"
            onClick={() => {
              dispatch(modalClose());
            }}
          />
        </div>
        <div className="BulkRequestExcelValidationErrorModal__content">
          <div className="BulkRequestExcelValidationErrorModal__message box-4x">
            <div className="space-2x">
              <svg height="22" width="25">
                <path
                  d="M13.825 1.216a3 3 0 011.007 1.008l8.937 14.72a3 3 0 01-2.564 4.556H3.33a3 3 0 01-2.564-4.557l8.936-14.72a3 3 0 014.122-1.007zM12.26 15.652c-.832 0-1.456.672-1.456 1.536s.624 1.536 1.456 1.536 1.472-.672 1.472-1.536-.64-1.536-1.472-1.536zm1.184-9.312h-2.368l.08 2.224.336 5.904h1.536l.336-5.904.08-2.224z"
                  fill="#FF1E1E"
                  fillRule="evenodd"
                />
              </svg>
            </div>
            <div>
              <p className="BulkRequestExcelValidationErrorModal__message--bold">
                데이터에 오류가 있습니다.
              </p>
              <p>
                우측의 오류들을 확인해 주세요.
                <br />
                오류를 해결한 뒤 엑셀파일을
                <br />재 업로드해 주세요.
              </p>
            </div>
            <div className="BulkRequestExcelValidationErrorModal__excel-upload-button">
              <BulkRequestExcelUploadButton
                bulkRequestId={bulkRequestId}
                isModal
                text="엑셀 재 업로드"
              />
            </div>
          </div>
          <ul className="BulkRequestExcelValidationErrorModal__errors box-3x">
            {errors.map((error, index) => (
              <ExcelValidationError
                columnName={error.columnName}
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                message={error.message}
                type={error.type}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

BulkRequestExcelValidationErrorModal.propTypes = propTypes;
BulkRequestExcelValidationErrorModal.defaultProps = defaultProps;

export default BulkRequestExcelValidationErrorModal;
